jQuery(function ($) {
    if ($('.has-parallax').length === 0) {
        return;
    }
    var $win = $(window);
    // console.log('parallax init');
    $win.on('scroll', updateParallax);

    // run on scroll + once on load
    updateParallax();


    function updateParallax() {
        var winTop = $win.scrollTop();
        var winHeight = $win.height();
        var winBottom = winTop + winHeight;

        $('.has-parallax').each(function () {
            var $container = $(this);
            var offsetTop = $container.offset().top;
            var height = $container.outerHeight();
   
            var $img = $(this).find('> img').first();
            // var orgPoxX = 50;
            // var orgPoxY = 50;

            var elTop = Math.round(offsetTop);
            var elBottom = Math.round(offsetTop + height);
            var distance = height + winHeight;

            if($img && $img.length > 0) {
                var orgPosX = 50;
                var orgPosY = 50;

                var obj_pos = $img.data('object-position');

                if( obj_pos ) {
                    var bg_pos = obj_pos.split(' ');
                    var orgPosX = parseFloat(bg_pos[0]);
                    var orgPosY = parseFloat(bg_pos[1]);
                }
    
            
                
                var speed = $container.data('parallax-speed') || 20;
    
                
                var startPercent = orgPosY - speed;
                if(startPercent < 0) startPercent = 0;
                var endPercent = orgPosY + speed;
                if(endPercent > 100) endPercent = 100;


                if (winBottom > elTop && winTop < elBottom) {
                    var percentageDone = parseFloat(((winBottom - elTop) / distance) * 100 );
                    var distInP = endPercent - startPercent;
                    var travel = endPercent - (percentageDone / 100) * distInP;
                    $img.css('object-position', orgPosX + '% ' + travel + '%');
                }
            }

     

            // check if container has style 'background-image':
            if ($container.css('background-image') && $container.css('background-image') !== 'none') {
                var bgPosX = 50;
                var bgPosY = 50;

                var bg = $container.css('background-position');
                if(bg) {
                    bg_pos = bg.split(' ');
                    bgPosX = parseFloat(bg_pos[0]);
                    bgPosY = parseFloat(bg_pos[1]);
                }
                // var bg_pos = $container.css('background-position').split(' ');
                var speed = 20;



                let speedtest = $container.css('--tswp-parallax-speed');
                speedtest = parseFloat(speedtest) || 0;
                speedtest = speedtest * 5;
                var speed = speedtest || 20;                                
                
                var startPercent = orgPosY - speed;
                if(startPercent < 0) startPercent = 0;
                var endPercent = orgPosY + speed;
                if(endPercent > 100) endPercent = 100;
                var orgPosX = 50;
               

                if (winBottom > elTop && winTop < elBottom) {
                    var percentageDone = parseFloat(((winBottom - elTop) / distance) * 100 );
                    distInP = endPercent - startPercent;
                    travel = endPercent - (percentageDone / 100) * distInP;
                    $img.css('object-position', orgPosX + '% ' + travel + '%');
                    $container.css('background-position', orgPosX + '% ' + travel + '%');
                }
            }

            
        });
    }

    
});